import styled from "styled-components";

const AboutUsStylesStylesContainer = styled.section`
    margin: 0 0 30px;
    border-top: 2px solid #e6e5e5;

    .page-details {
        padding: 40px 0;

        .desc1 {
            line-height: 30px;
        }
        .img-sec {
            height: 144px;
            width: 144px;
            
            @media screen and (min-width: 768px) {
                margin-top: 15px;
                margin-left: 25px;
            }
            @media screen and (max-width: 767px) {
                margin-left: auto;
                margin-right: auto;
            }
        }
    }
`;

export { AboutUsStylesStylesContainer };
